// @flow
import React from 'react';
import styled, { type StyledComponent } from 'styled-components';

import creditCardSprite from '../../../images/credit-cards@2x.png';
import { CARD_TYPES } from '../../../constants/creditCard.constants';
import type { CreditCardType } from '../../../types/CreditCard';

const CardIcon: StyledComponent<{}> = styled.span`
  display: inline-block;
  width: 32px;
  min-width: 32px;
  height: 22px;
  margin-right: 8px;
  background-image: url(${creditCardSprite});
  background-repeat: no-repeat;
  background-size: cover;
`;

const VisaIcon: StyledComponent<React$ElementConfig<typeof CardIcon>, {}, any> = styled(CardIcon)`
  background-position: 0 0;
`;

const AmexIcon: StyledComponent<React$ElementConfig<typeof CardIcon>, {}, any> = styled(CardIcon)`
  background-position: 0 -44px;
`;

const MastercardIcon: StyledComponent<React$ElementConfig<typeof CardIcon>, {}, any> = styled(
  CardIcon
)`
  background-position: 0 -88px;
`;

const DiscoverIcon: StyledComponent<React$ElementConfig<typeof CardIcon>, {}, any> = styled(
  CardIcon
)`
  background-position: 0 -132px;
`;

export type Props = {
  type: ?CreditCardType,
};

const CreditCardIcon = ({ type, ...other }: Props) => {
  const cardType = CARD_TYPES[type && type.toLowerCase()] || {};
  switch (cardType.id) {
    case CARD_TYPES.visa.id:
      return <VisaIcon {...other} />;
    case CARD_TYPES.amex.id:
      return <AmexIcon {...other} />;
    case CARD_TYPES.mastercard.id:
      return <MastercardIcon {...other} />;
    case CARD_TYPES.discover.id:
      return <DiscoverIcon {...other} />;
    default:
      return null;
  }
};

CreditCardIcon.defaultProps = {
  type: undefined,
};

export default CreditCardIcon;



// WEBPACK FOOTER //
// ../react-lib/src/components/typography/CreditCardIcon/CreditCardIcon.jsx